// src/components/Login.jsx
import { useState } from 'react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from "firebase/auth"
import { doc, getDoc, getFirestore } from 'firebase/firestore';
import { auth } from "../../Firebase"; 
import './login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const db = getFirestore();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      // Login the user with Firebase Auth
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Check the user's role from Firestore
      const userDoc = await getDoc(doc(db, 'users', user.uid));

      if (userDoc.exists()) {
        const role = userDoc.data().role;

        // Redirect to different dashboard based on role
        if (role === 'admin') {
          navigate('/adminhome');  // Redirect admin to admin dashboard
        } else {
          navigate('/home');  // Redirect regular user to user dashboard
        }
      } else {
        setError('User not found');
      }
    } catch (err) {
      setError('Invalid email or password');
    }
  };


  return (
    <div className="login-background">
      <div className="hibiscus hibiscus-1"></div>
      <div className="hibiscus hibiscus-2"></div>
      <div className="butterfly butterfly-1"></div>
      <div className="butterfly butterfly-2"></div>
      <div className="butterfly butterfly-3"></div>
      <img className="hibiscusimg" src="https://cdn-icons-png.flaticon.com/512/8174/8174547.png" alt="hibiscus" />

      <div className="login-container">
        <h1 className='login-h1'>Login</h1>
        <form onSubmit={handleLogin}>
          <input
            className='login-input'
            type="email"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
          className='login-input'
            type="password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" className='login-btn'>Login</button>
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </form>
        <p className='p-login'>Don't have an account? <a href="/register" className='a-login'>Register</a></p>
      </div>
    </div>
  );
}
